<template>
    <div class="fill-height">
        <v-container fluid class="mt-0 pt-6" v-if="current_list.ID > 0">
            <v-row dense align="center" justify="center">
                <v-col cols="12">

                    <!-- NEW LEAD DIALOG -->
                    <dialog-new-leads></dialog-new-leads>

                    <v-row>

                        <!-- LEFT COLUMN -->
                        <v-col cols="4" class="pt-0">
                            <!-- SEARCH AND TAGS BOX -->
                            <v-sheet class="pa-3 mb-2" rounded elevation="1">
                                <v-row>
                                    <v-col cols="6">
                                        <!-- BM: SEARCH FIELD -->
                                        <v-text-field v-model="lead_search" append-icon="mdi-magnify" label="Search" single-line
                                            hide-details
                                            clearable
                                            @click:clear="resetFilteredLeads()"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>

                                    <!-- BM: TAGS DISPLAY/TOGGLE -->
                                    <!-- <v-chip v-for="tag in allTags" small :outlined="!selected_tags.includes(tag)"
                                        :dark="selected_tags.includes(tag)" :key="tag" color="blue" class="mx-1 mb-1"
                                        @click="toggleSelectedTag(tag)">{{tag}}</v-chip>
                                    <v-btn v-if="selected_tags.length > 0" icon color="secondary lighten-1" class="mx-1"
                                        @click="selected_tags = []">
                                        <v-icon>mdi-close-circle</v-icon>
                                    </v-btn> -->
                                    <v-col cols="6">
                                        <v-combobox 
                                            outlined 
                                            :items="allTags" 
                                            v-model="selected_tags" 
                                            multiple
                                            dense
                                            clearable
                                            placeholder="Filter by Tag"
                                            hide-details
                                        ></v-combobox>
                                    </v-col>
                                </v-row>
                            </v-sheet>

                            <!-- LEADS -->

                            <!-- BM: LEADS TABLE TOP -->
                            <v-card
                                class="elevation-1" 
                                style="border:none;" 
                                :loading="leads_loading"
                                loading-text="Loading..." 
                            >
                                <!-- <v-card-title>
                                    <span style="display:inline-block;margin-top:10px;">
                                        Leads
                                        <span v-if="false && selected_leads.length > 0">({{selected_leads.length}} selected)</span>
                                    </span>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon @click="app.new_lead_dialog.show = true; app.new_lead_dialog.tab = 0;"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon>
                                                    mdi-plus
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Add New Leads</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn 
                                                icon
                                                v-bind="attrs"
                                                v-on="on" 
                                                @click="app.new_lead_dialog.show = true; app.new_lead_dialog.tab = 1;"
                                            >
                                                <v-icon>
                                                    mdi-tray-arrow-up
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Upload List</span>
                                    </v-tooltip>
                                </v-card-title>

                                <v-divider></v-divider> -->

                                <v-tabs grow v-model="left_tabs">
                                    <v-tab class="pt-4 pb-2">Contacts
                                        <v-btn icon @click="app.new_lead_dialog.show = true; app.new_lead_dialog.tab = 0;"
                                                x-small
                                                class="ml-2"
                                                outlined
                                                color="primary"
                                            >
                                                <v-icon>
                                                    mdi-plus
                                                </v-icon>
                                            </v-btn>
                                    </v-tab>
                                    <v-tab class="pt-4 pb-2">
                                        <v-badge color="accent" v-if="Object.keys(app.tasks).length > 0" :content="Object.keys(app.tasks).length">Tasks</v-badge>
                                        <span v-else>Tasks</span>
                                    </v-tab>
                                    <v-tab class="pt-4 pb-2"><v-badge color="accent" content="7">Inbox</v-badge></v-tab>
                                </v-tabs>

                                <v-tabs-items v-model="left_tabs">
                                    <v-tab-item>

                                        <!-- <v-btn icon @click="app.new_lead_dialog.show = true; app.new_lead_dialog.tab = 0;"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon>
                                                mdi-plus
                                            </v-icon>
                                        </v-btn> -->

                                        <!-- BM: Leads List/Table -->
                                        <v-card-text :style="`height: calc((100vh - 233px) - ${app.bottom_height}px); overflow: auto;`" v-scroll.self="onScroll">
                                            <v-list dense>
                                                <template v-for="(contact, i) in filteredLeads">
                                                    <v-divider
                                                        v-if="!contact"
                                                        :key="`divider-${i}`"
                                                    ></v-divider>

                                                    <v-list-item
                                                        v-else
                                                        :key="contact.ID"
                                                        :value="contact"
                                                            @click="gotoContact(contact)"
                                                        :class="contactClass(contact)"
                                                        dense
                                                    >
                                                        <v-list-item-content dense>
                                                            <v-list-item-title v-html="format_lead_title(contact)"></v-list-item-title>
                                                            <v-list-item-content dense>
                                                                <v-container dense class="pa-0 ma-0">
                                                                    <v-row dense v-for="phone_number in scanContactForPhoneNumbers(contact)" :key="phone_number">
                                                                        <v-col cols="10" dense style="line-height:32px;">
                                                                            {{app.phoneNumberFormat(phone_number)}} 
                                                                            {{app.phoneNumberStatus(phone_number)}}
                                                                        </v-col>
                                                                        <v-col cols="2" dense class="text-right">
                                                                            <v-btn
                                                                                fab
                                                                                x-small
                                                                                elevation="0"
                                                                                @click.prevent="dialContact(contact, phone_number)"
                                                                                :class="app.phoneNumberStatusColor(phone_number)"
                                                                            >
                                                                                <v-badge color="accent" 
                                                                                    v-if="app.contacts_unread_messages[contact.ID] && app.contacts_unread_messages[contact.ID].length > 0"
                                                                                    :content="app.contacts_unread_messages[contact.ID].length">
                                                                                    <v-icon>mdi-phone</v-icon>
                                                                                </v-badge>
                                                                                <v-icon v-else>mdi-phone</v-icon>
                                                                            </v-btn>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-container>
                                                            </v-list-item-content>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-list>
                                        </v-card-text>

                                    </v-tab-item>

                                    <!-- TASKS TAB ITEM -->
                                    <v-tab-item>
                                        <v-card-text :style="`height: calc((100vh - 232px) - ${app.bottom_height}px); overflow: auto;`">
                                            <v-list>
                                                <v-list-item-group
                                                    v-model="current_task"
                                                >
                                                    <template v-for="(item, i) in app.tasks">
                                                        <v-divider
                                                            v-if="!item"
                                                            :key="`divider-${i}`"
                                                        ></v-divider>

                                                        <v-list-item
                                                            v-else
                                                            :key="item.ID"
                                                            :value="item"
                                                            @click="gotoContact(item.contact)"
                                                        >
                                                            <!-- <v-list-item-action>
                                                                <v-checkbox color="accent" v-model="item.complete"></v-checkbox>
                                                            </v-list-item-action> -->

                                                            <v-list-item-content>
                                                                <v-list-item-title v-html="format_lead_title(item)"></v-list-item-title>
                                                                <v-list-item-subtitle>{{current_list.post_title}}: {{item.contact.post_title}}</v-list-item-subtitle>
                                                                <v-list-item-subtitle class="text--disabled">
                                                                    {{app.formatDateUTC(item.post_date)}}
                                                                </v-list-item-subtitle>
                                                            </v-list-item-content>
                                                            <v-list-item-action>
                                                                <v-list-item-action-text v-text="app.formatRelativeDateUTC(item.post_date)"></v-list-item-action-text>

                                                                <v-icon
                                                                v-if="!item.completed"
                                                                color="grey lighten-1"
                                                                >
                                                                mdi-star-outline
                                                                </v-icon>

                                                                <v-icon
                                                                v-else
                                                                color="yellow darken-3"
                                                                >
                                                                mdi-star
                                                                </v-icon>
                                                            </v-list-item-action>
                                                        </v-list-item>
                                                    </template>
                                                </v-list-item-group>
                                            </v-list>
                                        </v-card-text>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card-text :style="`height: calc((100vh - 232px) - ${app.bottom_height}px); overflow: auto;`">
                                            Inbox
                                        </v-card-text>
                                    </v-tab-item>
                                </v-tabs-items>
                                
                                <!-- <v-card-actions>
                                    Records: 
                                </v-card-actions> -->
                            </v-card>
                        </v-col>

                        <!-- BM: MIDDLE COLUMN -->
                        <v-col cols="4" v-if="current_list.ID > 0" class="pa-0">
                            <v-sheet class="pa-3 mb-2" rounded elevation="1">
                                <!-- BM: SELECT LIST -->
                                <v-autocomplete :items="lists.lists" item-text="post_title" item-value="ID" :return-object="true"
                                    v-model="current_list" dense outlined hide-details="" label="Lists">
                                    <template v-slot:append>
                                        <v-btn icon @click="lists.show_create_dialog = true">
                                            <v-icon>
                                                mdi-plus
                                            </v-icon>
                                        </v-btn>
                                        <v-btn icon @click="lists.show_edit_dialog = true">
                                            <v-icon>
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                    </template>

                                    <!-- Unread Message Count for list items -->
                                    <template v-slot:item="{item}">
                                        {{item.post_title}}
                                        <v-spacer></v-spacer>
                                        <v-chip v-if="app.unread_messages[item.ID]" x-small color="accent">{{Object.keys(app.unread_messages[item.ID]).length}}</v-chip>
                                    </template>

                                    <!-- Unread Message Count for selected list -->
                                    <template v-slot:selection="{item}">
                                        {{item.post_title}}
                                        <v-chip v-if="app.unread_messages[item.ID]" x-small color="accent">{{Object.keys(app.unread_messages[item.ID]).length}}</v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-sheet>

                            <!-- Communications window -->
                            <communications v-if="current_lead && current_lead.ID > 0 && phone_number.length > 0" :phone_number="phone_number"></communications>

                        </v-col>

                        <!-- BM: RIGHT COLUMN -->
                        <v-col cols="4" class="py-0 px-3" v-if="current_list.ID > 0">
                            
                            <dialer v-model="phone_number"></dialer>

                            <v-hover v-slot="{ hover }" close-delay="1000">
                                <v-sheet class="pa-3" rounded v-if="current_lead && current_lead.ID > 0" :style="`height:calc(100vh - ${278+app.bottom_height}px);overflow:auto;`" elevation="1">
                                    <v-fab-transition>
                                        <v-btn fab absolute right x-small color="secondary" elevation="0" v-show="hover"
                                            @click="show_delete_lead = true" style="margin-top:-7px;">
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-fab-transition>

                                    <!-- Lead Title -->
                                    <div class="pa-2 font-weight-bold" v-if="current_lead && current_lead.ID > 0 && !editLeadTitle"
                                        @click="clickedTitle">
                                        <div class="caption grey--text">Lead</div>
                                        <div v-if="current_lead && current_lead.ID > 0" v-html="format_lead_title(current_lead)"></div>
                                    </div>
                                    <v-textarea v-if="current_lead && current_lead.ID > 0 && editLeadTitle" label="Lead" auto-grow class="pa-2 body-2"
                                        v-model="current_lead.post_title" rows="1" v-click-outside="clickOutside"></v-textarea>

                                    <!-- Lead Notes -->
                                    <div class="pa-2 body-2" v-if="current_lead && current_lead.ID > 0 && !editLeadNotes"
                                        @click.prevent="clickedNotes">
                                    <!-- <div class="pa-2 body-2" v-if="current_lead.ID > 0 && !editLeadNotes"> -->
                                        <div class="caption grey--text">Notes</div>

                                        <v-row v-for="(line, index) in current_lead.post_content.split(/\r?\n/)" :key="`${index}:${line}`" dense>

                                            <!-- TASK? -->
                                            <template v-if="contains_task_date(line, index)">
                                                <v-col cols="1"><v-checkbox color="accent" dense hide-details v-model="contact_tasks[`'${current_lead.ID}'`][index].complete" @change="updateTaskStatus($event, index)"></v-checkbox></v-col>
                                                <v-col cols="11" class="pt-3" v-html="format_lead_content(line)"></v-col>
                                            </template>
                                            
                                            <!-- PLAIN NOTE/TEXT -->
                                            <template v-else-if="!containsFieldName(line)">
                                                <v-col cols="12" v-html="format_lead_content(line)" style="line-height:1.8;"></v-col>
                                            </template>
                                            
                                            <!-- FIELD/VALUE -->
                                            <template v-else>
                                                <v-col cols="3" class="font-weight-bold">{{line.substring(0, line.indexOf(":"))}}:</v-col>
                                                <v-col cols="9" v-html="format_lead_content(line.substring(line.indexOf(':')+1))"></v-col>
                                            </template>

                                        </v-row>
                                    </div>
                                    <v-textarea v-if="current_lead.ID > 0 && editLeadNotes" label="Notes" auto-grow class="pa-2 body-2" style="line-height:1.5"
                                        v-model="current_lead.post_content" v-click-outside="clickOutside"></v-textarea>
                                </v-sheet>
                            </v-hover>
            
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-speed-dial
			v-model="fab"
			direction="top"
            absolute
			bottom
			right
			open-on-hover
			transition="slide-y-reverse-transition"
			>
                <template v-slot:activator>
                    <v-btn
                    v-model="fab"
                    color="blue darken-2"
                    dark
                    fab
                    >
                    <v-icon v-if="fab">
                        mdi-close
                    </v-icon>
                    <v-icon v-else>
                        mdi-account-circle
                    </v-icon>
                    </v-btn>
                </template>
                <v-tooltip left :value="`true`">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            dark
                            small
                            color="green"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <span>Left tooltip</span>
                </v-tooltip>
                <v-btn
                    fab
                    dark
                    small
                    color="indigo"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-btn
                    fab
                    dark
                    small
                    color="red"
                >
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </v-speed-dial>


        </v-container>

        <!-- DEFAULT / LOADING / NO LIST SELECTED -->
        <v-container class="fill-height" fluid v-if="current_list.ID == null && user.code != 'login_required'">
            <!-- INITIAL LOADING INDICATOR -->
            <v-container v-if="lists.loading" class="text-center" fluid>
                <v-progress-circular indeterminate color="primary" :size="70" :width="7"></v-progress-circular>
                <div class="text-overline">Loading</div>
            </v-container>
        </v-container>

        <dialog-delete-lead v-if="show_delete_lead" @close="closeDeleteDialog" :req="app.req" :lead="current_lead"></dialog-delete-lead>

    </div>
</template>

<script>
    // import Settings from './Settings.vue'
    import Communications from './Communications'
    import Dialer from './Dialer'
    import DialogDeleteLead from './dialogs/DeleteLead.vue'
    import { useAppStore } from '../stores/app'
    import { useUserStore } from '../stores/user'
    import { useListsStore } from '../stores/lists'
    import { useLeadsStore } from '../stores/leads'
    import DialogNewLeads from './dialogs/NewLeads.vue'
    import * as chrono from 'chrono-node'
    import Pusher from 'pusher-js'
    

    
    export default {
        name: 'LeadDialer',
        components: {
            // Settings,
            Communications,
            DialogDeleteLead,
            Dialer,
            DialogNewLeads
        },
        created() {
            this.user = useUserStore()
            this.lists = useListsStore()
            this.app = useAppStore()
            this.leads = useLeadsStore()
        },
        data() {
            return {
                fab: false,
                app: null,
                leads: [],
                selected_lead: [],
                selected_leads: [],
                show_new_lead_dialog: false,
                user: null,
                show: 'lists',
                lead_dialer: [],
                interval: null,
                in_call: false,
                phone_number: "",
                lists: [{
                    ID: 0,
                    post_title: ""
                }],
                headers: [{
                    text: 'List Name',
                    align: 'start',
                    sortable: true,
                    value: 'post_title',
                }],
                lists_loading: false,
                list_dialog: false,
                current_list: {
                    post_title: "",
                    ID: null
                },
                saving_list: false,
                leads_headers: [
                    {
                        text: 'Leads',
                        align: 'start',
                        sortable: true,
                        value: 'post_title',
                    }, {
                        text: '',
                        align: 'center',
                        value: 'actions',
                        sortable: false
                    }
                ],
                lead_dialog: false,
                leads_loading: false,
                saving_lead: false,
                current_lead: {
                    ID: null,
                    post_title: "",
                    post_content: "",
                },
                current_lead_notes: "",
                csv_file: null,
                expanded: [],
                tags: ['Tag'],
                selected_tags: [],
                lead_search: "",
                editLeadTitle: false,
                editLeadNotes: false,
                selectedListItem: null,
                edit_list_dialog: false,
                show_delete_lead: false,
                alert: {
                    color: '',
                    show: false,
                    text: ''
                },
                contacts_table_key: null,
                shift_key_active: false,
                contact_tasks: [],
                left_tabs: 0,
                current_task: [],
            }
        },
        mounted: function () {
            this.fetchList(this.$route.params.id)
            this.lists.fetchLists()
            this.contacts_table_key = this.app.contacts_table_key
            var g = this
            window.onkeydown = function(e){
                if(e.key == 'Shift') {
                    g.shift_key_active = true
                }
            }
            window.onkeyup = function(e){
                if(e.key == 'Shift') {
                    g.shift_key_active = false
                }
            }
            // this.subscribe()
        },
        computed: {
            getPostContent: function () {
                return "more notes here"
            },
            filteredLeads: function () {
                return this.leads.leads.filter(lead => {

                    //no tags slected and no search text
                    if (this.selected_tags.length == 0 && this.lead_search == "")
                        return true

                    //check search string
                    if ((this.lead_search != null && this.lead_search != "")
                        && (lead.post_title.toLowerCase().indexOf(this.lead_search.toLowerCase()) > -1 
                        || lead.post_content.toLowerCase().indexOf(this.lead_search.toLowerCase()) > -1))
                        return true

                    let has_tag = false
                    this.selected_tags.forEach((tag, index) => {
                        if (lead.post_title.indexOf(tag) > -1 || lead.post_content.indexOf(tag) > -
                            1) {
                            has_tag = true
                        }
                    })
                    if (has_tag)
                        return true
                    return false
                })
            },
            resetFilteredLeads: function() {
                console.log("resetFilteredLeads")
            },
            allTags: function () {
                let tags = this.tags
                tags.sort()
                return tags
            }
        },
        methods: {
            contactClass: function(contact) {
                var contact_class = contact.dialing ? 'blob-disabled': ''
                if("dark:", this.$vuetify.theme.dark)
                    contact_class += this.$route.params.contact_id == contact.ID ? ' grey darken-3' : ''
                else
                    contact_class += this.$route.params.contact_id == contact.ID ? ' grey lighten-3' : ''
                return contact_class
            },
            subscribe: function() {
                console.log("LD subscribe")
                let pusher = new Pusher('48bff4f1fa51477735f7', { cluster: 'us2' })
                pusher.bind('call_status', data => {
                    this.app.updateCallStatus(data)
                })
            },
            dialContact: function(contact, phone_number) {
                console.log("dial contact", contact)
                contact.dialing = true
                this.app.make_call({to: phone_number, contact_id: contact.ID})
            },
            updateTaskStatus(checked, index) {
                // console.log(checked, index)
                let lines = this.current_lead.post_content.split(/\r?\n/)

                //remove all previous [x]'s
                lines[index] = lines[index].replace(/\[x\]\s/g, '')

                if(checked)
                    lines[index] = `[x] ${lines[index]}`
                
                this.current_lead.post_content = lines.join("\n")
                this.saveLead()
            },
            containsFieldName: function(line) {
                //only look at the first 20 characters
                let text = line.substr(0,20)

                if(text.indexOf(":") == -1)
                    return false

                // first colon isn't part of a link/url
                if(['http', 'ttps'].includes(text.substr(text.indexOf(':') - 4, 4)))
                    return false

                return true
            },
            onScroll: function(e) {
                // console.log("onScroll", e.target.scrollTop, e.target.clientHeight, e.target.scrollTop + e.target.clientHeight, e.target.scrollHeight)    
                if(e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight - 1) {
                    this.getMoreContacts()
                    // this.getMoreMessages()
                }
            },
            handleListBoxInput(e) {
            },
            closeDeleteDialog(deleted) {
                if (deleted) {
                    this.resetCurrentLead()
                    this.getLeads(this.current_list)
                }
                this.show_delete_lead = false
            },
            clickedTitle: function (e) {
                if (e.srcElement.tagName !== "A")
                    this.editLeadTitle = true
            },
            clickedNotes: function (e) {
                if (e.srcElement.tagName !== "A" && e.srcElement.className.indexOf("v-input") == -1) {
                    var g = this
                    setTimeout(function() {
                        g.editLeadNotes = true
                    }, 100)
                }
            },
            rowClass: function (lead) {
                if (lead == this.current_lead)
                    return "primary"
                    // return "grey darken-2 rowClass"
                return "rowClass"
            },
            editLead: function (lead) {
                // console.log("edit lead")
                //scan lead for dates/tasks before rendering
                lead.post_content = this.formatContentDates(lead.post_content)

                this.current_lead = lead
                this.app.current_lead = lead
                this.selected_lead = lead
                this.editLeadTitle = false
                this.editLeadNotes = false
            },
            formatContentDates(text) {

                //rewrites any relative dates (i.e. Call tomorrow at 3) into calendar dates
                //this should be called before rendering and before saving
                let parsed_date = chrono.parse(text, new Date(), { forwardDate: true })
                parsed_date.forEach(date => {
                    let dt = moment(date.start.date()).format('ddd, MMM D YYYY, h:mm a')
                    text = text.replace(date.text, dt)
                })
                return text
            },
            gotoContact: function(contact) {
                if(!this.current_lead) {
                    // console.log("no current lead", contact)
                    this.current_lead = contact
                    this.app.current_lead = contact
                }
                if(this.current_lead && contact.ID == this.current_lead.ID) {
                    return
                }

                // this.selected_leads = [contact]
                if(this.shift_key_active) {
                    this.selected_leads.push(contact)
                    return
                }

                // this.$router.push({ name: 'Contact', params: { id: this.$route.params.id, contact_id: contact.ID }})
                if(this.$route.params.id != contact.post_parent)
                    this.$router.push({ name: 'Contact', params: { id: contact.post_parent, contact_id: contact.ID }})
                else if (this.$route.params.contact_id != contact.ID) 
                    this.$router.push({ name: 'Contact', params: { contact_id: contact.ID }})

                this.editLead(contact)
                if(contact.meta)
                    contact.meta.dialernow_unread_msg = []
            },
            scanTextForPhoneNumbers: function(text) {
                // let text = `${this.current_lead?.post_title} ${this.current_lead?.post_content}`

                //replace quotes and commas with spaces to help with the search
                text = text.replace(/"/g, " ")
                text = text.replace(/,/g, " ")

                //remove long numbers that aren't phone numbers
                text = text.replace(/[0-9]{12,}/img, "")

                
                let all_matches = []

                //10 digits together
                let matches1 = text.match(/(\+1)?[-\s\.]?[0-9]{10}$/img) || []      //end of string
                let matches2 = text.match(/(\+1)?[-\s\.]?[0-9]{10}[\n|\s]/img) || [];    //end of line or space after

                //now look for (###) ###-####
                let matches3 = text.match(/(\+1)?[-\s\.]?[(]?[0-9]{3}[)][-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}/img) || [];

                //###-###-#### or ###.###.####
                let matches4 = text.match(/[0-9]{3}[-\.][0-9]{3}[-\.][0-9]{4}/img) || [];

                all_matches.push(...this.formatPhoneNumbers(matches1), ...this.formatPhoneNumbers(matches2), ...this.formatPhoneNumbers(matches3), ...this.formatPhoneNumbers(matches4))
                let final_matches = new Set(all_matches)
                return Array.from(final_matches)
            },
            scanContactForPhoneNumbers: function(contact) {
                return this.scanTextForPhoneNumbers(`${contact?.post_title} ${contact?.post_content}`)
            },
            scanCurrentLeadForPhoneNumber: function () {
                this.phone_number = this.scanTextForPhoneNumbers(`${this.current_lead?.post_title} ${this.current_lead?.post_content}`)
            },
            formatPhoneNumbers(phoneNumbers) {
                return phoneNumbers.map(phoneNumber => {
                    let number = phoneNumber.replace(/\D/g,'')
                    return number[0] == "1" ? number.substr(1) : number
                })
            },
            toggleSelectedTag(tag) {
                if (!this.selected_tags.includes(tag)) {
                    //add tag
                    this.selected_tags.push(tag)
                } else {
                    //remove tag
                    let old_tags = this.selected_tags
                    this.selected_tags = old_tags.filter(old_tag => old_tag != tag)
                }

            },
            expandRow: function (item, slot) {
                slot.expand(!slot.isExpanded)
            },
            onTitleInput: function (e) {
                this.current_lead.post_title = e.target.innerText
            },
            onInput: function (e) {
                this.current_lead.post_content = e.target.innerText
            },
            sendKey: function (e) {
                if (["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "*", "#"].includes(e.key)) {
                    if (this.call) {
                        this.call.sendDigits(e.key)
                    }
                }
            },
            handleAddClick: function () {
                if (this.show == 'lists') {
                    this.list_dialog = true
                }

                if (this.show == 'leads') {
                    this.lead_dialog = true
                }

            },
            newListName: function(name) {
                this.newListName = name
            },
            clickOutside: function(e) {
                // this will hide the textarea and cause the notes to re-render
                // the render process updates the list of tasks for this contact
                this.editLeadNotes = false
                var g = this
                //use a timeout to give time for the task list to update as the notes render in html
                setTimeout(function(){
                    g.saveLead()
                }, 200)
            },
            saveLead: function () {
                this.saving_lead = true
                this.editLeadTitle = false
                this.editLeadNotes = false

                let data = {...this.current_lead, tasks: this.contact_tasks[`'${this.current_lead.ID}'`]}
                data.post_content = this.formatContentDates(data.post_content)

                this.app.req.post(`lead`, data)
                    .then(data => {
                        // this.lead_dialog = false
                        this.saving_lead = false
                        this.app.getTasks()
                    })
                this.scanCurrentLeadForPhoneNumber()
            },
            getLeads: function (list = null) {
                if(!list)
                    list = this.current_list
                    
                this.selectedListItem = list.ID
                // this.lists.current_list = list
                this.current_list = list
                // this.current_lead = null
                this.leads_loading = true
                this.show = 'leads'
                this.tags = []
                this.selected_tags = []

                this.getMoreContacts()

            },
            getMoreContacts: function() {
                this.app.req.get(`lists/${this.current_list.ID}/leads?offset=${this.leads.leads.length}`).then(data => {
                    if(this.leads.leads.length == 0)
                        this.leads.leads = data.leads
                    else
                        this.leads.leads.push(...data.leads)
                    this.leads_loading = false
                    // console.log("total", data.total)
                    this.editContactById(this.$route.params.contact_id)
                })
            },
            editContactById: function(contact_id) {
                if(!contact_id)
                    return

                let contact = this.leads.leads.find(lead => lead.ID == contact_id)
                this.editLead(contact)
            },
            format_lead_title: function (lead) {
                let title = lead.post_title
                let matches = title.match(
                    /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/g);
                if (matches) {
                    matches.forEach(url => {
                        title = title.replace(url,
                            `<a href="${url}" target="_blank"><i aria-hidden="true" class="v-icon notranslate mdi mdi-open-in-new theme--dark ml-1" style="font-size:1em;"></i></a>`
                            )
                    })
                }
                title = this.replaceHashTags(title)
                let temp_text = this.replaceHashTags(lead.post_content)
                return title
            },
            contains_task_date: function(text, index) {
                //scans the text for any sudo dates
                let dates = chrono.parse(text, new Date(), { forwardDate: true })
                if(dates.length == 0 && text.indexOf('[x]') == -1 && text.indexOf('[]') == -1 && text.indexOf('[ ]') == -1) {
                    return false
                }
                
                var start_date = dates.length > 0 ? dates[0].start.date() : null
                // console.log(text, text.replace(/\[\]\s/g, ''))
                //add to the contact_tasks object which will be sent back to the server to save with post meta
                if(text.indexOf('[x]') > -1)
                    this.contact_tasks[`'${this.current_lead.ID}'`][index] = {complete: true, text: text.replace(/\[x\]\s/g, ''), date: start_date}
                else
                    this.contact_tasks[`'${this.current_lead.ID}'`][index] = {complete: false, text: text.replace(/\[\]\s/g, ''), date: start_date}
                
                return true
            },
            format_lead_content: function (text, index) {
                let matches = text.match(
                    /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/g);
                if (matches) {
                    matches.forEach(url => {
                        text = text.replace(url,
                            `<a href="${url}" target="_blank" onclick="console.log('clicked')">${url}</a>`
                            )
                    })
                }

                // scan for dates
                let parsed_date = chrono.parse(text, new Date(), { forwardDate: true })
                parsed_date.forEach(date => {
                    let dt = moment(date.start.date()).format('ddd, MMM D YYYY, h:mm a')
                    let relative = moment(date.start.date()).fromNow()
                    text = text.replace(date.text, `<span style="text-decoration:underline">${dt}</span> (${relative})`)
                    // this.current_lead.post_content = this.current_lead.post_content(date.text, dt)
                })

                // hide the task status indicator if it exists
                text = text.replace(/\[x?\] /g, '')
               
                //TODO: make sure not to replace hashtags in a URL - check for white space before hashtag
                text = this.replaceHashTags(text)
                if (text != "")
                    return text.replace(/\n/g, '<br />')
                
                return text
            },
            replaceHashTags: function (text) {
                if (this.editLeadTitle || this.editLeadNotes)
                    return text

                let matches = text.match(/#(\S*)/g);
                if (matches) {
                    matches.forEach(tag => {

                        //default tag color
                        let color = "primary"

                        //use tag as the color if it matches one of these colors
                        if(['red', 'pink', 'purple', 'indigo', 'cyan', 'teal', 'green', 'lime', 'orange', 'yellow', 'amber', 'brown', 'grey', 'black'].includes(tag.replace("#", ""))){
                            color = tag.replace("#","")
                        }

                        //strip non alphanumeric chars from tag
                        tag = tag.replace(/[^a-z0-9]/gi, '')

                        if (isNaN(tag[1]) && tag.length > 1) {
                            text = text.replace(`#${tag}`, `<span style="font-weight:bold;" class="${color} white--text px-2 py-1 rounded-pill caption">#${tag}</span>`)
                        }

                        if (!this.tags.includes(tag) && isNaN(tag[1]) && tag.length > 1)
                            this.tags.push(tag)
                    })
                }
                
                return text
            },
            resetCurrentLead: function () {
                this.current_lead = {
                    ID: null,
                    post_title: "",
                    post_content: "",
                }
                this.app.current_lead = this.current_lead
            },
            fetchList (ID) {
                if(!ID)
                    return
                    
                let g = this
                // this.app = useAppStore()
                this.lists.loading = true
                this.app.get(`lists/${ID}`)
                    .then(data => {
                        this.current_list = data.data
                        this.lists.loading = false
                        // this.getLeads(this.current_list)
                    })
                    .catch(error => {
                        this.app.showError('Could not retrieve the requested list')
                        this.lists.loading = false
                    })
            },
            // phoneNumberStatus: function(phone_number) {
            //     let call = this.app.getCallStatusByPhoneNumber(`+1${phone_number}`)
            //     if(call.CallStatus)
            //         return `${call.CallStatus ?? ''} ${call.AnsweredBy ?? ''}`
            //     return ''
            // },
            // phoneNumberStatusColor: function(phone_number) {
            //     let call = this.app.getCallStatusByPhoneNumber(`+1${phone_number}`)
            //     if(call.Status == 'dialing') 
            //         return 'warning'
            //     if(call.Status == 'ringing') 
            //         return 'warning'
            //     if(call.Status == 'in-progress' && call.AnsweredBy == 'human') 
            //         return 'success'
            //     if(call.Status == 'in-progress' && call.AnsweredBy != 'human') 
            //         return 'warning'
            //     return ''
            // }
        },
        watch: {
            'current_lead': function (newV) {
                if(!newV)
                    return
                this.scanCurrentLeadForPhoneNumber()
                this.contact_tasks[`'${newV.ID}'`] = []
            },
            current_list: function (newV, oldV) {
                if(newV.ID != this.$route.params.id){
                    this.leads = {leads: []}
                    this.resetCurrentLead()
                    this.$router.push({ name: 'List', params: { id: newV.ID }})
                }
                this.getLeads(newV)
            },
            '$route.params.id': function(newV, oldV) {
                console.log("list id changed", newV, oldV)
            }
        }
    }
</script>
<style lang="scss">
    input,
    textarea {
        border: none !important;
        background-color: transparent !important;
        box-shadow: none !important;
    }
    .rowClass {
        cursor: pointer;
    }
    .entry-content table:not(.variations) {
        border: none !important
    }
    .v-input__append-inner {
        margin-top: 10px !important;
    }
    #leads_table .v-data-table__wrapper {
        height:calc(100vh - 292px);
    }

    .blob {
        box-shadow: 0 0 0 0 rgba(0, 255, 0, 1);
        transform: scale(0.97);
        animation: pulse 2s infinite;
    }

    .blob2 {
        border-radius: 50%;
        box-shadow: 0 0 0 0 rgba(0, 255, 0, 1);
        transform: scale(1);
        animation: pulse 3s infinite;
    }

    @keyframes pulse {
        0% {
            transform: scale(0.97);
            box-shadow: 0 0 0 0 rgba(0, 255, 0, 1);
        }

        70% {
            transform: scale(.97);
            box-shadow: 0 0 0 5px rgba(0, 255, 0, 0.5);
        }

        100% {
            transform: scale(0.97);
            box-shadow: 0 0 0 0 rgba(0, 255, 0, 1);
        }
    }

</style>